import { useState } from "react";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import useController from "./controller";
import useBaseForm from "../../hooks/useBaseForm";
import useBreakPoints from "../../hooks/useBreakPoints";
import { parseErrors } from "../../lib/requestHelpers";
import { validateFieldsWithException } from "../../lib/validation";
import { t } from "../../locales";
import { FormValues } from "../../types";

export default function useViewController(
  appointmentId: string,
  onClose: () => void,
  onFeedbackAdded?: (review: Review) => void
) {
  const { desktopUp } = useBreakPoints();
  const [showSuccessStatus, setShowSuccessStatus] = useState(false);
  const [processing, setProcessing] = useState(false);
  const { fields, values, errors, setValues, setErrors } = useBaseForm([
    {
      name: "comment",
      type: "textarea",
      labelClassName: "d-block mb-2",
      className: "leave-coach-feedback-modal__textarea",
      label: `*${t("Your feedback")}`,
      autoGrow: true,
      maxRows: desktopUp ? 6 : 8,
      maxLength: 500,
      showLengthCounter: true,
      validation: {
        required: true,
      },
    },
  ]);
  const { publishFeedback } = useController(appointmentId);
  const onChange = (formValues: FormValues) => setValues(formValues);

  const onPublishFeedback = async () => {
    try {
      validateFieldsWithException(fields, values);
      setProcessing(true);
      const review = await publishFeedback(values["comment"]);
      onFeedbackAdded && onFeedbackAdded(review);
      setShowSuccessStatus(true);
    } catch (e) {
      setErrors(parseErrors(e));
    } finally {
      setProcessing(false);
    }
  };

  const onCloseModal = () => {
    setShowSuccessStatus(false);
    onChange({});
    setErrors({});
    onClose();
  };

  return {
    fields,
    values,
    errors,
    onChange,
    setErrors,
    onPublishFeedback,
    processing,
    showSuccessStatus,
    onCloseModal,
  };
}
